import { ajustes } from '@/service/api'

export default async function () {
    return Promise.all([
        ajustes.aprovados.invalidateQueries(),
        ajustes.relatorioAusencias.invalidateQueries(),
    ])
}
